/* eslint-disable react/prop-types */
import React, { useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import styled from 'styled-components'

import { MIN_CHARS } from '../../constants'
import useAcknowledgeOptions from '../../hooks/useAcknowledgeOptions'
import AcknowledgeResolution from './AcknowledgeResolution'
import AlarmCardText from './AlarmCardText'

const Title = styled.span`
    color: #364159 !important;
    margin-left: 4px;
`

const Viewer = styled(function ({ className, channel, batch = [], curves, selectedUnitSet, AlarmsComponent }) {
    const alarms = batch
        .filter(item => item.ref.mnemonic === channel)
        .map(item => ({
            ...item,
            description: (
                <div>
                    {item.severity}
                    <Title>
                        {(!item.ref?.id?.startsWith('user') ? '[global] ' : ' ') +
                            (item.trigger.alarm.ruleDescription ?? '')}
                    </Title>
                </div>
            ),
            text: <AlarmCardText alarm={item} selectedUnitSetCurves={selectedUnitSet?.data || {}} curves={curves} />,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:MM')
        }))

    const reasonTransform = useCallback(
        r =>
            r.reduce(
                (options, option) => ({
                    ...options,
                    [option.reason.toLowerCase().replace(/\s+/g, '_')]: {
                        label: option.reason,
                        color: option.color
                    }
                }),
                {}
            ),
        []
    )

    const reasonOptions = useAcknowledgeOptions('reason', 'reasons', reasonTransform, false)
    const resolutionOptions = useAcknowledgeOptions(
        'resolution',
        'resolutions',
        useCallback(r => r, []),
        useMemo(() => ({ resolution: 'Other' }), [])
    )

    const AcknowledgeResolutionWithOptions = props => <AcknowledgeResolution {...props} options={resolutionOptions} />

    return (
        <div className={className}>
            {alarms.length > 0 ? (
                <AlarmsComponent
                    batch={alarms}
                    event={{ title: null }}
                    modalCustomizations={{
                        canClose: ({ closeAlarm: { workOrder, reason, extra } }) => {
                            if (!reason) return false
                            if (!workOrder) return false

                            const resolutionIsOther = (extra?.resolution || '').toLowerCase() === 'other'
                            if (resolutionIsOther && (extra?.resolutionDetails || '').trim().length < MIN_CHARS) {
                                return false
                            }

                            return true
                        },
                        displayWorkOrder: () => false,
                        additionalComponents: {
                            resolution: AcknowledgeResolutionWithOptions
                        },
                        ...(Object.keys(reasonOptions).length ? { reasonOptions } : {})
                    }}
                />
            ) : (
                <div className="no-alarms">No Active Alarms for this channel.</div>
            )}
        </div>
    )
})`
    > div > div {
        background: #fff;
        padding: 0;
    }

    .no-alarms {
        display: flex;
        height: 200px;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }

    > div > div > div > div > h3 {
        -webkit-line-clamp: initial;
    }
`

function mapStateToProps({ dashboardReducer, editorReducer }) {
    return {
        batch: dashboardReducer.batch,
        curves: editorReducer.curves
    }
}

export default connect(mapStateToProps)(Viewer)
